import { ExternalLink } from "lucide-react"
import { CardView } from "shared/src/components/CardView/CardView"
import { useIsInIframe } from "shared/src/hooks"

interface IframePopOutButtonProps {
	bottom?: number
}

export function IframePopOutButton({ bottom }: IframePopOutButtonProps = {}) {
	const popout = () => {
		window.open(document.location.href)
	}

	const show = useIsInIframe()

	const bottomPosition = bottom !== undefined ? bottom : 20
	const positionStyle = { position: "fixed" as const, bottom: bottomPosition, left: 8, padding: 5, zIndex: 100 }

	return (
		show && (
			<CardView style={positionStyle}>
				<ExternalLink
					onClick={popout}
					className="clickable"
					style={{ color: "var(--primary)", width: 25, height: 25 }}></ExternalLink>
			</CardView>
		)
	)
}
